"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductController = void 0;
const plattar_api_1 = require("@plattar/plattar-api");
const product_ar_1 = require("../../ar/product-ar");
const util_1 = require("../../util/util");
const plattar_controller_1 = require("./plattar-controller");
/**
 * Manages an instance of the <plattar-product> HTML Element
 */
class ProductController extends plattar_controller_1.PlattarController {
    constructor(parent) {
        super(parent);
    }
    onAttributesUpdated() {
        const state = this._state;
        // re-render the QR Code when attributes have changed
        if (state === plattar_controller_1.ControllerState.QRCode) {
            this.startQRCode(this._prevQROpt);
            return;
        }
        // use the messenger function to change variation when attributes have changed
        if (state === plattar_controller_1.ControllerState.Renderer) {
            const viewer = this._element;
            if (viewer) {
                const variationID = this.getAttribute("variation-id");
                if (variationID && viewer.messenger) {
                    viewer.messenger.selectVariation(variationID);
                }
            }
            return;
        }
    }
    startViewerQRCode(options) {
        return new Promise((accept, reject) => {
            // remove the old renderer instance if any
            this.removeRenderer();
            const productID = this.getAttribute("product-id");
            if (productID) {
                const opt = options || this._GetDefaultQROptions();
                const viewer = document.createElement("plattar-qrcode");
                // required attributes with defaults for plattar-viewer node
                const width = this.getAttribute("width") || "500px";
                const height = this.getAttribute("height") || "500px";
                viewer.setAttribute("width", width);
                viewer.setAttribute("height", height);
                if (opt.color) {
                    viewer.setAttribute("color", opt.color);
                }
                if (opt.margin) {
                    viewer.setAttribute("margin", "" + opt.margin);
                }
                if (opt.qrType) {
                    viewer.setAttribute("qr-type", opt.qrType);
                }
                viewer.setAttribute("shorten", (opt.shorten && (opt.shorten === true || opt.shorten === "true")) ? "true" : "false");
                // optional attributes
                const variationID = this.getAttribute("variation-id");
                const variationSKU = this.getAttribute("variation-sku");
                const showAR = this.getAttribute("show-ar");
                let dst = plattar_api_1.Server.location().base + "renderer/product.html?product_id=" + productID;
                if (variationID) {
                    dst += "&variationId=" + variationID;
                }
                if (variationSKU) {
                    dst += "&variationSku=" + variationSKU;
                }
                if (showAR) {
                    dst += "&show_ar=" + showAR;
                }
                viewer.setAttribute("url", opt.url || dst);
                viewer.onload = () => {
                    return accept(viewer);
                };
                this.append(viewer);
                this._element = viewer;
                this._state = plattar_controller_1.ControllerState.QRCode;
                this._prevQROpt = opt;
                return;
            }
            return reject(new Error("ProductController.startQRCode() - minimum required attributes not set, use product-id as a minimum"));
        });
    }
    startRenderer() {
        return new Promise((accept, reject) => {
            // remove the old renderer instance if any
            this.removeRenderer();
            const productID = this.getAttribute("product-id");
            if (productID) {
                // required attributes with defaults for plattar-product node
                const width = this.getAttribute("width") || "500px";
                const height = this.getAttribute("height") || "500px";
                const server = this.getAttribute("server") || "production";
                const viewer = document.createElement("plattar-product");
                viewer.setAttribute("width", width);
                viewer.setAttribute("height", height);
                viewer.setAttribute("server", server);
                viewer.setAttribute("product-id", productID);
                // optional attributes
                const variationID = this.getAttribute("variation-id");
                const variationSKU = this.getAttribute("variation-sku");
                const showAR = this.getAttribute("show-ar");
                if (variationID) {
                    viewer.setAttribute("variation-id", variationID);
                }
                if (variationSKU) {
                    viewer.setAttribute("variation-sku", variationSKU);
                }
                if (showAR) {
                    viewer.setAttribute("show-ar", showAR);
                }
                viewer.onload = () => {
                    return accept(viewer);
                };
                this.append(viewer);
                this._element = viewer;
                this._state = plattar_controller_1.ControllerState.Renderer;
                return;
            }
            return reject(new Error("ProductController.startRenderer() - minimum required attributes not set, use scene-id as a minimum"));
        });
    }
    initAR() {
        return new Promise((accept, reject) => {
            if (!util_1.Util.canAugment()) {
                return reject(new Error("ProductController.initAR() - cannot proceed as AR not available in context"));
            }
            const productID = this.getAttribute("product-id");
            if (productID) {
                const variationID = this.getAttribute("variation-id");
                const variationSKU = this.getAttribute("variation-sku");
                const product = new product_ar_1.ProductAR(productID, variationID, variationSKU);
                return product.init().then(accept).catch(reject);
            }
            return reject(new Error("ProductController.initAR() - minimum required attributes not set, use product-id as a minimum"));
        });
    }
    removeRenderer() {
        if (this._element) {
            this._element.remove();
            this._element = null;
            return true;
        }
        return false;
    }
    get element() {
        return this._element;
    }
}
exports.ProductController = ProductController;
